(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Folder', Folder);

    /* @ngInject */
    function Folder($resource, DateUtils) {
        var resourceUrl = 'api/folders/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET'
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
